import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

import {ProjectService} from '@catcore/services';
import {Project} from '@catcore/types/api-v2';
import {ProjectDetailsService} from '@catdetails/services';
import {Subscription} from 'rxjs/Subscription';

@Component({
  templateUrl: './project-details.component.html',
})
export class ProjectDetailsComponent implements OnInit, OnDestroy {

  public currentProject: Project;
  constructor(private route: ActivatedRoute,
              private projectService: ProjectService,
              private projectDetailsService: ProjectDetailsService) {
  }

  ngOnInit() {
    this.projectService.getCurrent().subscribe((project: Project) => this.currentProject = project);
  }

  ngOnDestroy() {
    this.projectDetailsService.unloaded();
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/project-details/components/project-details/project-details.component.ts